// extracted by mini-css-extract-plugin
export default {"container":"contactsProfileInfo_container__xZM+M","contact":"contactsProfileInfo_contact__WKuRp"};